import { render, staticRenderFns } from "./addCustomRecord.vue?vue&type=template&id=0cddf7f8&scoped=true&"
import script from "./addCustomRecord.vue?vue&type=script&lang=js&"
export * from "./addCustomRecord.vue?vue&type=script&lang=js&"
import style0 from "./addCustomRecord.vue?vue&type=style&index=0&id=0cddf7f8&prod&lang=scss&"
import style1 from "./addCustomRecord.vue?vue&type=style&index=1&id=0cddf7f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cddf7f8",
  null
  
)

export default component.exports